<template>
  <b-table
    :items="items"
    :fields="fields"
    :empty-text="$t('GERAL.NENHUM_REGISTRO')"
    head-variant="light"
    stacked="md"
    show-empty
    striped
    hover
    @sort-changed="aoMudarOrdenacao"
  >
    <template #cell(acoes)="item">
      <b-dropdown variant="outline-default" v-if="podeEditar || podeExcluir">
        <b-dropdown-item @click="editar(item.item)" v-if="podeEditar">
          {{ $t('GERAL.EDITAR') }}
        </b-dropdown-item>
        <b-dropdown-item @click="excluir(item.item)" v-if="podeExcluir">
          {{ $t('GERAL.EXCLUIR') }}
        </b-dropdown-item>
      </b-dropdown>
    </template>
  </b-table>
</template>
<script>
// Utils & Aux:
import Permissoes from '@/components/mixins/permissoes';
import helpers from '@/common/utils/helpers';

export default {
  mixins: [Permissoes],
  props: { items: { type: Array, default: Array } },
  data() {
    return {
      fields: [
        {
          key: 'descricao',
          label: this.$t('GERAL.DESCRICAO'),
          sortable: true,
        },
        {
          key: 'percentual',
          label: this.$t('GERAL.VALOR_PORCENTAGEM'),
          sortable: true,
          formatter: (value) => {
            return value ? `${value}%` : '-';
          },
        },
        {
          key: 'valor',
          label: this.$t('GERAL.VALOR_BRL'),
          sortable: true,
          formatter: (value) => {
            return value ? helpers.formatarReal(value) : '-';
          },
        },
        {
          key: 'dataValidade',
          label: this.$t('GERAL.VALIDADE'),
          sortable: true,
          formatter: (value) => {
            return value ? helpers.formatarDataBr(value) : '-';
          },
        },
        {
          key: 'tipoDescontoDescricao',
          label: this.$t('GERAL.TIPO'),
          sortable: true,
        },
        {
          key: 'acoes',
          label: this.$t('GERAL.ACOES'),
        },
      ],
    };
  },
  methods: {
    editar(item) {
      this.$emit('editar', 'desconto', item);
    },
    excluir(item) {
      this.$emit('excluir', item);
    },
    aoMudarOrdenacao({ sortBy, sortDesc }) {
      let campoOrdenado = helpers.primeiraLetraMaiuscula(sortBy)
      let ordem = sortDesc
      this.$emit('alterar-ordenacao', campoOrdenado, ordem);
    },
  },
};
</script>
